import React, { useRef } from 'react'
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers'

// Define simple Props interface that just receives the response data directly
type Props = {
  response: any;
  start_date?: string;
  end_date?: string;
  onClose?: () => void;
}

const ImpactModalCertFormTry: React.FC<Props> = ({
  response = {},
  start_date = '',
  end_date = '',
  onClose = () => { }
}) => {


  // console.log("response is", response.data[0])


  const certificateRef = useRef<HTMLDivElement>(null)

  const downloadCertificate = () => {
    if (!certificateRef.current) return

    // Open a new window with just the certificate content
    const printWindow = window.open('', '_blank')
    if (!printWindow) {
      alert('Please allow pop-ups to download the certificate')
      return
    }

    // Get the styles from the document to preserve the font and other necessary styles
    const styles = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          return Array.from(sheet.cssRules)
            .map((rule) => rule.cssText)
            .join(' ')
        } catch (e) {
          return '' // Skip stylesheets that cannot be accessed due to CORS policy
        }
      })
      .join(' ')

    // Write the certificate HTML and styles to the new window
    printWindow.document.write(`
    <html>
      <head>
        <title>Certificate</title>
        <style>
          /* Basic styles to keep font consistent */
          body {
            font-family: inherit; /* Inherit the font from the current document */
            margin: 0;
            padding: 0;
          }

          .certificate-container {
            width: auto;
            height: auto;
            margin: 0;
            padding: 0;
          }

          /* Include all styles from the current page to preserve fonts and layout */
          ${styles}
        </style>
      </head>
      <body>
        <div class="certificate-container">
          ${certificateRef.current.outerHTML}
        </div>
        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
              window.close();
            }, 500);  // Delay to ensure the content is fully loaded
          };
        </script>
      </body>
    </html>
  `)

    printWindow.document.close()
  }

  const headerName = [
    {
      label: 'Kilometers not driven in a car ( 1 km driven = 0.21 kg C02 )',
      value: 'totalCo2savingsEqv',
      image: toAbsoluteUrl('/media/logos/1.png'),
    },
    {
      label: 'Days of electricity for an average household ( 1 home uses — 20kWh/ day)',
      value: 'totalEnergySavingsEqv',
      image: toAbsoluteUrl('/media/logos/2.png'),
    },
    {
      label: 'Number of 10,000-liter water trucks(pipas) (1 pipa = 10,000 liters) ',
      value: 'totalWaterSavingsEqv',
      image: toAbsoluteUrl('/media/logos/4.png'),
    },
    {
      label: 'Number of pages not printed (leaves) (1 tree 8,333 A4 sheets of paper) ',
      value: 'totalTreeSavingsEqv',
      image: toAbsoluteUrl('/media/logos/3.png'),
    },
  ]

  return (
    <>
      <div ref={certificateRef} style={{ backgroundColor: 'white' }}>
        <div
          id='certificate-container'
          style={{
            display: 'flex',
            width: '944px',
            height: '665px',
            margin: '0 auto',
            backgroundColor: 'white',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
          }}
        >
          {/* Left side - Green background */}
          <div
            style={{
              width: '50%',
              backgroundColor: '#1f4133',
              padding: '24px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                position: 'absolute',
                marginTop: '-40px',
                width: '82%',
                left: 75, // Ensures it aligns to the left
                // Optional: add right: 0 to stretch
              }}
            >
              <div
                style={{
                  height: 140,
                  width: 140,
                  backgroundColor: 'transparent',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={response?.data?.[0]?.franchiseKyc?.[0]?.docUrl ?? ''}
                  alt='logo'
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              </div>

              <h2
                style={{
                  textAlign: 'center',
                  color: 'white',
                  paddingBottom: '8px',
                  borderBottom: '4px solid white',
                }}
              >
                {response?.data?.[0]?.customerName || ''}
              </h2>

              <p
                style={{
                  margin: 0,
                  color: 'white',
                  fontSize: '12px',
                  lineHeight: '1.4',
                  fontWeight: 'bold',
                }}
              >
                issued on <br />
                {new Date().toLocaleDateString()}
              </p>
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flex: 1,
                marginTop: '-30px',
                position: 'relative',
              }}
            >
              <img
                src={toAbsoluteUrl('/media/logos/logo_cert.png')}
                alt='Environmental Impact Circle'
                style={{ maxWidth: '85%' }}
              />

              {/* CO2 Value Overlay */}
              <div
                style={{
                  position: 'absolute',
                  top: '35%',
                  right: '42%',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  textAlign: 'center',
                }}
              >
                <div>
                  {response?.data?.[0]?.totalCo2savings
                    ? parseFloat(response.data[0].totalCo2savings).toFixed(2)
                    : '0.00'}

                </div>
              </div>

              {/* Trees Saved Overlay */}
              <div
                style={{
                  position: 'absolute',
                  top: '52%',
                  left: '18%',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  textAlign: 'center',
                }}
              >
                <div>
                  {response?.data?.[0]?.totalTreeSavings
                    ? parseFloat(response.data[0].totalTreeSavings).toFixed(2)
                    : '0.00'}

                </div>
              </div>

              {/* Water Liters Overlay */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '29%',
                  left: '44%',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  textAlign: 'center',
                }}
              >
                <div>
                  {response?.data?.[0]?.totalWaterSavings
                    ? parseFloat(response.data[0].totalWaterSavings).toFixed(2)
                    : '0.00'}

                </div>
              </div>

              {/* Energy Savings Overlay */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '48%',
                  right: '17%',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  textAlign: 'center',
                }}
              >
                <div>
                  {response?.data?.[0]?.totalEnergySavings
                    ? parseFloat(response.data[0].totalEnergySavings).toFixed(2)
                    : '0.00'}

                </div>
              </div>
            </div>

            <p
              style={{
                fontSize: '9px',
                bottom: '24px',
                maxWidth: '100%',
                textAlign: 'center',
                overflowWrap: 'break-word',
                wordWrap: 'break-word',
                hyphens: 'auto',
                marginTop: '-40px',
                color: 'white',
              }}
            >
              This Impact Certificate is powered by the Inclusiv Traceability Platform
            </p>
          </div>

          {/* Right side - Green background */}
          <div
            style={{
              width: '50%',
              backgroundColor: '#1f4133',
              padding: '24px',
              color: 'white',
              paddingTop: '100px',
            }}
          >
            <div>
              <p
                style={{
                  marginTop: "20px",
                  fontSize: '14px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
              >
                {response?.data?.[0]?.totalQuantity ? parseFloat(response.data[0].totalQuantity).toFixed(2) : '0.00'} kg
                Received <br />
                Period : {start_date} to {end_date}
              </p>
            </div>

            <div
              style={{
                width: '100%',
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              {headerName.map((x, ind) => (
                <div
                  key={ind}
                  style={{
                    display: 'flex',
                    marginBottom: '54px',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src={x.image}
                    alt={x.label}
                    style={{
                      width: '40px',
                      height: '40px',
                      marginRight: '14px',
                    }}
                  />

                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div>
                      <h3
                        style={{
                          fontSize: '14px',
                          fontWeight: 'bold',
                          margin: '0',
                          color: 'white',
                        }}
                      >
                        {response?.data?.[0]?.[x.value]?.toFixed(2) || '0.00'} {x.label}
                      </h3>
                    </div>
                  </div>
                </div>
              ))}

              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                }}
              >
                <img
                  alt='Logo'
                  src='/media/logos/enverify.png'
                  style={{
                    position: 'absolute',
                    bottom: '-83px',
                    right: '10px',
                    width: '100px',
                    height: 'auto',
                    zIndex: 1000,
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            height: 140,
            width: 140,
            backgroundColor: 'transparent',
            overflow: 'hidden',
            margin: '10px 0 10px 50px', // top, right, bottom, left
          }}
        >
          <img
            src={response?.data?.[0]?.franchiseKyc?.[0]?.docUrl ?? ''}
            alt='logo'
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>

        <div style={{ textAlign: 'center', width: '100%' }}>
          <h2
            style={{
              color: 'black',
              paddingBottom: '8px',
              borderBottom: '4px solid black',
              margin: "10px auto",
              display: 'inline-block',
            }}
          >
            {response?.data?.[0]?.customerName || ''}
          </h2>
        </div>

        <table
          style={{
            width: '90%',
            borderCollapse: 'collapse',
            marginTop: '10px',
            backgroundColor: 'white',
            fontSize: '12px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >

          <thead>
            <tr style={{ backgroundColor: '#333333', color: 'white' }}>
              <th style={{ padding: '10px', textAlign: 'left' }}>S.N</th>
              <th style={{ padding: '10px', textAlign: 'left' }}>Category</th>
              <th style={{ padding: '10px', textAlign: 'left' }}>Item</th>
              <th style={{ padding: '10px', textAlign: 'left' }}>Quality Collected</th>
              <th style={{ padding: '10px', textAlign: 'left' }}>GHG Saved</th>
              <th style={{ padding: '10px', textAlign: 'left' }}>Energy Saved</th>
              <th style={{ padding: '10px', textAlign: 'left' }}>Water Saved</th>
              <th style={{ padding: '10px', textAlign: 'left' }}>Trees Saved</th>
            </tr>
          </thead>
          <tbody>
            {response?.data?.[0]?.savings && response?.data?.[0]?.savings.map((item: any, index: number) => (
              <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
                <td style={{ padding: '8px', textAlign: 'left' }}>{index + 1}</td>
                <td style={{ padding: '8px', textAlign: 'left' }}>{item.categoryName || ''}</td>
                <td style={{ padding: '8px', textAlign: 'left' }}>{item.itemName || ''}</td>
                <td style={{ padding: '8px', textAlign: 'left' }}>
                  {item.itemQuantity ? parseFloat(item.itemQuantity).toFixed(2) : '0.00'}
                </td>
                <td style={{ padding: '8px', textAlign: 'left' }}>
                  {item.co2savings ? parseFloat(item.co2savings).toFixed(2) : '0.00'}
                </td>
                <td style={{ padding: '8px', textAlign: 'left' }}>
                  {item.energySavings ? parseFloat(item.energySavings).toFixed(2) : '0.00'}
                </td>
                <td style={{ padding: '8px', textAlign: 'left' }}>
                  {item.waterSavings ? parseFloat(item.waterSavings).toFixed(2) : '0.00'}
                </td>
                <td style={{ padding: '8px', textAlign: 'left' }}>
                  {item.treeSavings ? parseFloat(item.treeSavings).toFixed(2) : '0.00'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <p
          style={{
            fontSize: '9px',
            bottom: '24px',
            maxWidth: '100%',
            textAlign: 'center',
            overflowWrap: 'break-word',
            wordWrap: 'break-word',
            hyphens: 'auto',
            margin: '30px 0',
            color: 'black',
          }}
        >
          This Impact Certificate is powered by the Inclusiv Traceability Platform
        </p>
      </div>

      {/* Action buttons */}
      <div className='modal-footer gap-2'>
        <button
          style={{ backgroundColor: '#12B886' }}
          type='button'
          onClick={downloadCertificate}
          className='btn btn-primary'
        >
          Download Certificate
        </button>
        <button
          type='reset'
          onClick={onClose}
          className='btn btn-light me-3 ml-2'
          data-kt-users-modal-action='cancel'
        >
          Discard
        </button>
      </div>
    </>
  )
}

export default ImpactModalCertFormTry;